import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Link from 'next/link';
import _ from 'lodash';

import { withTranslation } from 'language/i18n';
import Breadcrumb from 'components/Breadcrumb';
import Layout from 'components/partials/Layout';
import Accordion from './components/Accordion';
import useFaqContent from './hooks/useFaqContent';

const Faq = ({ t, pageSlug }) => {
  const faqContent = useFaqContent();
  const [selectedFaqIndex, setSelectedFaqIndex] = useState(0);

  const breadcrumbs = [
    {
      label: t('homepage'),
      url: '/',
    },
    {
      label: t('faq'),
      url: '/faq/buyers',
    },
    {
      label: t(pageSlug),
      url: `/faq/${pageSlug}`,
    },
  ];

  return (
    <main className="has-header">
      <div className="container">
        <div className="row mt-4 mb-4 mt-lg-3 mb-lg-3">
          <div className="col">
            <Breadcrumb links={breadcrumbs} />
          </div>
        </div>
        <div className="row">
          <div className="col-md-5 col-lg-4">
            <aside className="im-left-menu">
              <nav className="im-content-nav">
                <Link href="/faq/buyers">
                  <a className={`im-content-nav__item ${pageSlug === 'buyers' ? 'im-content-nav__item--active' : ''}`}>Alıcılar için</a>
                </Link>
                <Link href="/faq/sellers">
                  <a className={`im-content-nav__item ${pageSlug === 'sellers' ? 'im-content-nav__item--active' : ''}`}>Satıcılar için</a>
                </Link>
              </nav>
            </aside>
          </div>
          <div className="col-md-10 col-lg-11 mt-3 mt-md-0">
            <div className="row mb-20">
              <div className="col">
                <h1 className="h1">{t('faq')}</h1>
              </div>
            </div>
            <div className="row mb-20">
              <div className="col-15">
                <nav className="im-tabs im-tabs--horizontal-bar">
                  {_.map(faqContent[pageSlug], (faq, index) => (
                    <a
                      key={index}
                      className={`im-tabs__tab ${selectedFaqIndex === index ? 'im-tabs__tab--active' : ''}`}
                      onClick={() => setSelectedFaqIndex(index)}
                    >
                      <span>{faq.title}</span>
                    </a>
                  ))}
                </nav>
              </div>
              <div className="col-15">
                <div className="tab-content tab-content--shadow">
                  <div className="tab-pane active">
                    <Accordion panels={faqContent[pageSlug][selectedFaqIndex].materials} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

Faq.propTypes = {
  t: PropTypes.func,
  pageSlug: PropTypes.string,
};

export const getServerSideProps = async ({ query, res }) => {
  if (query.faq !== 'buyers' && query.faq !== 'sellers') {
    res.writeHead(302, { Location: '/' });
    res.end();
  }

  return {
    props: {
      pageSlug: query.faq,
      blackHeader: true,
      headTitle: 'Sıkça Sorulan Sorular',
    },
  };
};

Faq.Layout = Layout;

export default withTranslation('common')(Faq);
